import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import { authStore } from "../store/auth-store";
import { cartStore } from "../store/cart-store";
import backendApi from "../apis/backend-api";
import ConfirmOrder from "../views/ConfirmOrder.vue";
import PointLists from "../views/PointLists.vue";
import LandingPage from "../views/LandingPage.vue";
import FAQ from "../views/FAQ.vue";
import Blank from "../views/Blank.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { requiresAuth: true },
    component: Home,
  },
  {
    path: "/landing",
    beforeEnter() {
      location.href = "/landing.html";
    },
  },
  {
    path: "/lp",
    beforeEnter() {
      location.href = "/lp.html";
    },
  },
  { path: "/faq", component: Blank },

  {
    path: "/term",
    name: "Faq",
    component: FAQ,
  },
  {
    path: "/points",
    name: "Point",
    component: PointLists,
  },

  {
    path: "/confirm_order",
    name: "ConfirmOrder",
    meta: { requiresAuth: true },
    component: ConfirmOrder,
  },
  {
    path: "/about",
    name: "About",
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/map",
    name: "Map",
    beforeEnter: async () => {
      await guestLogin();
    },
    // meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/Map.vue"),
  },
  {
    path: "/orikomi_map",
    name: "OrikomiMap",
    beforeEnter: async () => {
      await guestLogin();
    },
    // meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OrikomiMap.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    meta: { requiresAuth: true },

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Cart.vue"),
  },
  {
    path: "/orders",
    name: "Orders",
    meta: { requiresAuth: true },

    component: () => import("../views/Orders2.vue"),
  },
  {
    path: "/orders_orikomi",
    name: "OrdersOrikomi",
    meta: { requiresAuth: true },

    component: () => import("../views/OrdersOrikomi2.vue"),
  },
  {
    path: "/orders_geenie",
    name: "OrdersGeenie",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderGenie2.vue"),
  },
  {
    path: "/orders_ticket",
    name: "OrdersTicket",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderTicket.vue"),
  },
  {
    path: "/order/:id",
    name: "OrderDetail",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderDetail.vue"),
  },
  {
    path: "/order_orikomi/:order_key",
    name: "OrderDetailOrikomi2",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderDetailOrikomi2.vue"),
  },
  {
    path: "/order_geenie/:order_key",
    name: "OrderDetailGeenie",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderDetailGeenie.vue"),
  },
  {
    path: "/order_ticket/:order_key",
    name: "OrderDetailTicket",
    meta: { requiresAuth: true },

    component: () => import("../views/OrderDetailTicket.vue"),
  },
  {
    path: "/accounts/manage",
    name: "AccountsManage",
    meta: { requiresAuth: true },
    component: () => import("../views/AccountsManage.vue"),
  },
  {
    path: "/myAccount",
    name: "MyAccountManage",
    meta: { requiresAuth: true },
    component: () => import("../views/MyAccountManage.vue"),
  },
  {
    path: "/scroll_test",
    name: "ScrollTest",
    meta: { requiresAuth: true },

    component: () => import("../views/ScrollTest.vue"),
  },
  {
    path: "/init_register",
    name: "InitialRegister",
    meta: { requiresAuth: false },
    component: () => import("../views/InitialRegister.vue"),
  },
  {
    path: "/init_register_id",
    name: "InitialRegisterCustomerId",
    meta: { requiresAuth: false },
    component: () => import("../views/InitialRegisterCustomerId.vue"),
  },
  {
    path: "/term_use",
    name: "Term Use",
    meta: { requiresAuth: false },
    component: () => import("../views/Term_Use.vue"),
  },
  {
    path: "/forget_password",
    name: "ForgetPassword",
    meta: { requiresAuth: false },
    component: () => import("../views/ForgetPassword.vue"),
  },
  {
    path: "/stash_order",
    name: "Stash Order",
    meta: { requiresAuth: false },
    component: () => import("../views/BulkOrder.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const guestLogin = async () => {
  backendApi.guestLogin();
};

router.beforeEach((to, from, next) => {
  const isGuest = authStore.state.isGuest;
  if (isGuest) {
    if (to.path === "/") {
      location.href = "/landing.html";
      // next("/landing.html");
    } else if (to.path === "/lp") {
      location.href = "/lp.html"
    } else {
      next();
    }
  } else {
    next();
  }
  // if (
  //   to.path !== "/map" &&
  //   to.path !== "/orikomi_map" &&
  //   to.path !== "/login" &&
  //   to.path !== "/"
  // ) {
  //   if (isGuest) {
  //     if (to.path === "/") {
  //       next("/map");
  //     }
  //     next("/login");
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

router.beforeEach((to, from, next) => {
  const token = to.query.token;
  const isGuest = authStore.state.isGuest;
  if (token && token.length > 10) {
    authStore.commit("updateTokenFromParam", token);
    console.log(authStore.getters.isAuthorized);
  }

  if (from.path !== "/cart" && to.path === "/cart") {
    // ここで何らかの処理を行う
    if (isGuest) {
      next("/map");
    } else {
      console.log(
        "次の遷移先が '/cart' ですが、現在は '/cart' ではありません。"
      );
      cartStore.commit("updateCartStatus", 1);
    }
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !authStore.getters.isAuthorized
  ) {
    // next({ path: "/login", query: { redirect: to.fullPath } });
    next("/map");
    // location.href = "/login"
  } else {
    next();
  }
});

export default router;

//router
